//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import image from '../assets/LineageExample.png';
export default {
  name: 'ContLineageIframes',
  data: function data() {
    return {
      uris: null,
      image: image
    };
  },
  created: function created() {
    // redirect to http
    if (location.protocol.match(/^https/)) {
      location.href = location.href.replace(/^https/i, 'http');
    }

    // load monitoring
    var urisEncoded = this.$route.query.uris;
    if (urisEncoded) {
      var uriDecode = decodeURIComponent(urisEncoded);
      this.uris = JSON.parse(uriDecode);
    }
  }
};